/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M7 15.0001L10 18.0001M7 15.0001L10 12.0001M7 15.0001H11.6C13.8402 15.0001 14.9603 15.0001 15.816 14.5641C16.5686 14.1806 17.1805 13.5687 17.564 12.816C18 11.9604 18 10.8403 18 8.60008V7"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<rect
				x="2"
				y="2"
				width="20"
				height="20"
				rx="5"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<rect
				opacity="0.12"
				x="2"
				y="2"
				width="20"
				height="20"
				rx="5"
				fill="currentColor"
			/>
			<path
				d="M7 15.0001L10 18.0001M7 15.0001L10 12.0001M7 15.0001H10.4999C12.8297 15.0001 13.9946 15.0001 14.9135 14.6195C16.1386 14.112 17.1119 13.1386 17.6194 11.9136C18 10.9947 18 9.82978 18 7.5V7.5V7M10 22H14C16.8003 22 18.2004 22 19.27 21.455C20.2108 20.9757 20.9757 20.2108 21.455 19.27C22 18.2004 22 16.8003 22 14V10C22 7.19974 22 5.79961 21.455 4.73005C20.9757 3.78924 20.2108 3.02433 19.27 2.54497C18.2004 2 16.8003 2 14 2H10C7.19974 2 5.79961 2 4.73005 2.54497C3.78924 3.02433 3.02433 3.78924 2.54497 4.73005C2 5.79961 2 7.19974 2 10V14C2 16.8003 2 18.2004 2.54497 19.27C3.02433 20.2108 3.78924 20.9757 4.73005 21.455C5.79961 22 7.19974 22 10 22Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M3.98005 1.79497C5.04961 1.25 6.44974 1.25 9.25 1.25H14.75C17.5503 1.25 18.9504 1.25 20.02 1.79497C20.9608 2.27433 21.7257 3.03924 22.205 3.98005C22.75 5.04961 22.75 6.44974 22.75 9.25V14.75C22.75 17.5503 22.75 18.9504 22.205 20.02C21.7257 20.9608 20.9608 21.7257 20.02 22.205C18.9504 22.75 17.5503 22.75 14.75 22.75H9.25C6.44974 22.75 5.04961 22.75 3.98005 22.205C3.03924 21.7257 2.27433 20.9608 1.79497 20.02C1.25 18.9504 1.25 17.5503 1.25 14.75V9.25C1.25 6.44974 1.25 5.04961 1.79497 3.98005C2.27433 3.03924 3.03924 2.27433 3.98005 1.79497ZM18.75 6.99992C18.75 6.58571 18.4142 6.24992 18 6.24992C17.5858 6.24992 17.25 6.58571 17.25 6.99992V8.6C17.25 9.73248 17.2494 10.5367 17.198 11.1661C17.1473 11.7867 17.0509 12.171 16.8958 12.4755C16.5842 13.087 16.087 13.5842 15.4755 13.8958C15.171 14.0509 14.7867 14.1473 14.1661 14.198C13.5367 14.2494 12.7325 14.25 11.6 14.25H8.81066L10.5303 12.5303C10.8232 12.2374 10.8232 11.7626 10.5303 11.4697C10.2374 11.1768 9.76256 11.1768 9.46967 11.4697L6.46967 14.4697C6.17678 14.7626 6.17678 15.2374 6.46967 15.5303L9.46967 18.5303C9.76256 18.8232 10.2374 18.8232 10.5303 18.5303C10.8232 18.2374 10.8232 17.7626 10.5303 17.4697L8.81066 15.75H11.6H11.633H11.633C12.7252 15.75 13.5907 15.75 14.2883 15.693C15.0017 15.6347 15.6053 15.5131 16.1565 15.2323C17.0502 14.7769 17.7769 14.0502 18.2323 13.1565C18.5131 12.6053 18.6347 12.0017 18.693 11.2883C18.75 10.5907 18.75 9.72519 18.75 8.63309V8.63302V8.6V6.99992Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M9.5 2L9 2V2C7.13872 2 6.20808 2 5.45492 2.24472C3.93273 2.73931 2.73931 3.93273 2.24472 5.45492C2 6.20808 2 7.13872 2 9L2 14C2 16.8003 2 18.2004 2.54497 19.27C3.02434 20.2108 3.78924 20.9757 4.73005 21.455C5.79961 22 7.19974 22 10 22H14C16.8003 22 18.2004 22 19.27 21.455C20.2108 20.9757 20.9757 20.2108 21.455 19.27C22 18.2004 22 16.8003 22 14V9C22 7.13872 22 6.20808 21.7553 5.45492C21.2607 3.93273 20.0673 2.73931 18.5451 2.24472C17.7919 2 16.8613 2 15 2V2L14.5 2M7 15.0001L10 18.0001M7 15.0001L10 12.0001M7 15.0001H10.4999C12.8297 15.0001 13.9946 15.0001 14.9135 14.6195C16.1386 14.112 17.1119 13.1386 17.6194 11.9136C18 10.9947 18 9.82978 18 7.5V7.5V7"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M7 15.0001L10 18.0001M7 15.0001L10 12.0001M7 15.0001H10.4999C12.8297 15.0001 13.9946 15.0001 14.9135 14.6195C16.1386 14.112 17.1119 13.1386 17.6194 11.9136C18 10.9947 18 9.82978 18 7.5V7.5V7M10 22H14C16.8003 22 18.2004 22 19.27 21.455C20.2108 20.9757 20.9757 20.2108 21.455 19.27C22 18.2004 22 16.8003 22 14V10C22 7.19974 22 5.79961 21.455 4.73005C20.9757 3.78924 20.2108 3.02433 19.27 2.54497C18.2004 2 16.8003 2 14 2H10C7.19974 2 5.79961 2 4.73005 2.54497C3.78924 3.02433 3.02433 3.78924 2.54497 4.73005C2 5.79961 2 7.19974 2 10V14C2 16.8003 2 18.2004 2.54497 19.27C3.02433 20.2108 3.78924 20.9757 4.73005 21.455C5.79961 22 7.19974 22 10 22Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				opacity="0.32"
				d="M9.25 1.25C6.44974 1.25 5.04961 1.25 3.98005 1.79497C3.03924 2.27433 2.27433 3.03924 1.79497 3.98005C1.25 5.04961 1.25 6.44974 1.25 9.25V14.75C1.25 17.5503 1.25 18.9504 1.79497 20.02C2.27433 20.9608 3.03924 21.7257 3.98005 22.205C5.04961 22.75 6.44974 22.75 9.25 22.75H14.75C17.5503 22.75 18.9504 22.75 20.02 22.205C20.9608 21.7257 21.7257 20.9608 22.205 20.02C22.75 18.9504 22.75 17.5503 22.75 14.75V9.25C22.75 6.44974 22.75 5.04961 22.205 3.98005C21.7257 3.03924 20.9608 2.27433 20.02 1.79497C18.9504 1.25 17.5503 1.25 14.75 1.25H9.25Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M18 6.25C18.4142 6.25 18.75 6.58579 18.75 7V8.60008V8.6331C18.75 9.72523 18.75 10.5907 18.693 11.2883C18.6347 12.0017 18.5131 12.6054 18.2323 13.1565C17.7769 14.0503 17.0502 14.777 16.1565 15.2324C15.6053 15.5132 15.0017 15.6348 14.2883 15.6931C13.5906 15.7501 12.7252 15.7501 11.633 15.7501H11.6H8.81066L10.5303 17.4698C10.8232 17.7626 10.8232 18.2375 10.5303 18.5304C10.2374 18.8233 9.76256 18.8233 9.46967 18.5304L6.46967 15.5304C6.17678 15.2375 6.17678 14.7626 6.46967 14.4697L9.46967 11.4697C9.76256 11.1769 10.2374 11.1769 10.5303 11.4697C10.8232 11.7626 10.8232 12.2375 10.5303 12.5304L8.81066 14.2501H11.6C12.7325 14.2501 13.5367 14.2495 14.1661 14.1981C14.7867 14.1474 15.171 14.051 15.4755 13.8959C16.087 13.5843 16.5842 13.0871 16.8958 12.4755C17.0509 12.1711 17.1473 11.7868 17.198 11.1662C17.2494 10.5368 17.25 9.73256 17.25 8.60008V7C17.25 6.58579 17.5858 6.25 18 6.25Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
]);
